import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { ContentPlanRootState as S } from '../../../elements/contentPlan/store';
import { ElementAction } from '../../../elements/elementAction';
import { Functions } from '../../../types/types';
import { updatePlanningState } from '../../ContentPlanning/contentPlanningReducer';

const loadLastCreatedItem =
  (itemType: string): ElementAction<Functions, S> =>
  async (dispatch, getState, { getAPI }) => {
    const { getLastCreatedItem } = getAPI();
    if (itemType) {
      const resp = await getLastCreatedItem(itemType);
      if (resp?.data?.length) {
        const lastCreatedItems = getState().planning.lastCreatedItems || {};
        lastCreatedItems[itemType] = resp.data[0];
        dispatch(updatePlanningState({ lastCreatedItems }));
      }
    }
  };

export const useActions = () => {
  const dispatch: ThunkDispatch<S, any, any> = useDispatch();
  return {
    loadLastCreatedItem: (itemType: string) =>
      dispatch(loadLastCreatedItem(itemType))
  };
};
